import { isDate } from 'date-fns';

/**
 * @param birthday string in format mm/dd/yyyy
 * @returns
 */
export function isValidBirthday(birthday: string): boolean {
  const birthdayRegExp = /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)\d{2}/;
  return birthdayRegExp.test(birthday) && isValidDate(birthday);
}

/**
 * @param date string in format mm/dd/yyyy
 * @returns boolean
 */
export function isValidDate(date: string): boolean {
  const dateObj = new Date(date);
  const dateParts: string[] = date.split('/');

  return (
    isDate(dateObj) &&
    // This portion of the validation is to catch invalid/non-existent dates like Feb 31
    +dateParts[0] - 1 === dateObj.getMonth() && // Month is zero-based...
    +dateParts[1] === +dateObj.getDate() &&
    +dateParts[2] === +dateObj.getFullYear()
  );
}

export function isValidEmail(email: string): boolean {
  // Lovingly borrowed from https://regexr.com/3e48o
  const RFC2822EmailRegExp =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

  return RFC2822EmailRegExp.test(email);
}

export function isValidName(name: string): boolean {
  // This is to make sure a name  doesn't start with whitespaces. We shouldn't limit special chareacters or numbers. Thank you X Æ A-12...
  const nameRegExp = /^[^-\s][a-zA-Z0-9_\s-]+$/g;
  return nameRegExp.test(name);
}

export function isValidPhone(phone: string): boolean {
  const phoneRegExp = /^\([0-9]{3}\)\s?[0-9]{3}-[0-9]{4}$/;
  return phoneRegExp.test(phone);
}

/**
 * Digit-count check for phone numbers that haven't gone through the
 * (xxx) xxx-xxxx mask yet (e.g. raw values forwarded to a server route).
 */
export function hasTenDigits(phone: string): boolean {
  return phone.replace(/\D/g, '').length === 10;
}

export function isValidCityName(city: string): boolean {
  const cityRegExp = /^\s*[a-zA-Z]{1}[0-9a-zA-Z][0-9a-zA-Z '-.=#/]*$/;
  return cityRegExp.test(city);
}

export function isValidAddress(address: string): boolean {
  const addressRegExp = /^\d{1,5}\s+[a-zA-Z0-9\s,.'#-]+$/;
  return addressRegExp.test(address);
}

/**
 * Validates if a string matches the Vivrelle SKU format
 * Valid format examples: PHGV49964, PJFEN47209, PJCA47545
 * Pattern: P + 2-4 uppercase letters + 3-5 digits
 */
export const isValidVivrelleSku = (sku: string): boolean => {
  const skuRegex = /^P[A-Z]{2,4}\d{3,5}$/;
  return skuRegex.test(sku);
};
